// import { Description } from "@material-ui/icons";

export const experienceData = [
    {
        id: 1,
        company: 'Microsoft',
        jobtitle: 'Data Analyst Intern',
        startYear: 'Jan 2024',
        endYear: 'Apr 2024'
    },
    {
        id: 2,
        company: 'Merilytics',
        jobtitle: 'Senior Business Analyst',
        startYear: 'Feb 2023',
        endYear: 'Jul 2023'
    },
    {
        id: 3,
        company: 'Hindustan Unilever Limited',
        jobtitle: 'Senior Analyst, Supply Chain',
        startYear: 'Aug 2020',
        endYear: 'Jan 2023'
    }
]